module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-cell', {
    attrs: {
      "title": "基本设置",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toSetting('SiteSettingBase')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "人员设置",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toSetting('SiteSettingUser')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-323f2232","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/site/SiteSettingIndex.vue
// module id = 2315
// module chunks = 0